<template>
  <div class="login-box">
    <div class="fullScreen" @click="fullscreen">
      <i :class="isFullscreen? 'iconfont icon-tuichuquanping':'iconfont icon-ln_quanping'"></i>
    </div>
    <div class="login-form">
      <div class="top-text">02</div>
      <div class="login-header">
        <div class="text-title">新兴县火龙果智慧种植系统</div>
        <div class="english">设置新密码</div>
      </div>
      <el-form>
        <el-form-item>
          <div class="lable">新密码:</div>
          <div class="input-icon">
            <img class="img-icon" :src="passwordUrl" alt />
            <input
              type="password"
              class="input"
              v-model="from.newPass"
              v-on:input="newPassEvent"
              placeholder="请输入新密码"
            />
          </div>
          <div class="hint">新密码由数字、大小写字母组成，至少8~20位</div>
        </el-form-item>
        <el-form-item>
          <div class="lable">确认密码:</div>
          <div class="input-icon">
            <img class="img-icon" :src="affirmPassUrl" alt />
            <input
              type="password"
              class="input"
              v-model="from.affirmPass"
              v-on:input="affirmPassEvent"
              placeholder="请再次确认新密码"
            />
          </div>
        </el-form-item>
      </el-form>
      <div class="login-btn">
        <div class="btn" @click="login">登录</div>
        <div class="return" @click="getBack">返回</div>
      </div>
    </div>
  </div>
</template>
<script>
import password from "../../assets/login/password.png";
import passwordFocus from "../../assets/login/passwordFocus.png";
import newPass from "../../assets/login/newPass.png";
import newPassFocus from "../../assets/login/newPassFocus.png";
import screenfull from "screenfull";
export default {
  data() {
    return {
      passwordUrl: password,
      affirmPassUrl: newPass,
      from: {
        newPass: "",
        affirmPass: ""
      },
      isFullscreen: false
    };
  },
  created() {
    let that = this;
    window.onresize = function() {
      if (screenfull.isFullscreen) {
        that.isFullscreen = true;
      } else {
        that.isFullscreen = false;
      }
    };
  },
  methods: {
    fullscreen() {
      screenfull.toggle();
      this.isFullscreen = true;
    },
    newPassEvent() {
      if (this.from.newPass.length != 0) {
        this.passwordUrl = passwordFocus;
      } else {
        this.passwordUrl = password;
      }
    },
    affirmPassEvent() {
      if (this.from.affirmPass.length != 0) {
        this.affirmPassUrl = newPassFocus;
      } else {
        this.affirmPassUrl = newPass;
      }
    },
    login() {},
    getBack() {
      this.$router.push({
        path: "/forgetpass"
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.login-box {
  width: 100%;
  height: 100%;
  background: url("../../assets/login/bg.png") no-repeat;
  background-size: 100% 100%;
  position: relative;
  .fullScreen {
    position: absolute;
    right: 40px;
    top: 20px;
    i {
      font-size: 30px;
      color: #9ad2b6;
    }
  }
  .login-form {
    width: 700px;
    padding: 80px 88px 0 90px;
    box-sizing: border-box;
    position: absolute;
    top: 70px;
    left: 1120px;
    .top-text {
      font-size: 50px;
      font-family: PangMenZhengDao;
      font-weight: 400;
      color: rgba(16, 196, 106, 0.2);
      position: absolute;
      top: 10px;
      left: 20px;
    }
    .login-header {
      padding-top: 10px;
      .english {
        font-size: 30px;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #141414;
        line-height: 51px;
      }
      .text-title {
        font-size: 40px;
        font-family: HuXiaoBo-NanShen;
        font-weight: 700;
        color: rgba(16, 196, 106, 1);
        line-height: 51px;
      }
    }
    .el-form {
      margin-top: 44px;
      .lable {
        font-size: 20px;
        font-family: Source Han Sans CN;
        font-weight: 500;
        color: #131313;
        line-height: 50px;
        padding-left: 10px;
      }

      .input-icon {
        height: 40px;
        width: 100%;
        border-bottom: 1px solid rgba(153, 153, 153, 1);
        position: relative;

        .input {
          width: 91%;
          outline: none;
          border: 0px;
          background: transparent;
          line-height: 40px;
          font-size: 18px;
          padding-left: 15px;
          box-sizing: border-box;
        }
      }
      .hint {
        font-size: 16px;
        font-family: Source Han Sans CN;
        font-weight: 500;
        color: #9a9a9a;
        line-height: 36px;
      }
      .img-icon {
        padding-left: 10px;
      }

      .el-form-item {
        margin-bottom: 30px;
      }
    }
  }
  .login-btn {
    margin-top: 40px;
    display: flex;
    .btn {
      cursor: pointer;
      width: 250px;
      height: 50px;
      background-color: #10c469;
      text-align: center;
      font-size: 20px;
      font-family: Source Han Sans CN;
      font-weight: bold;
      color: #ffffff;
      line-height: 50px;
      box-shadow: 9px 6px 16px #d4f4e4;
    }
    .return {
      cursor: pointer;
      width: 250px;
      height: 50px;
      background-color: #b2ffd9;
      text-align: center;
      font-size: 20px;
      font-family: Source Han Sans CN;
      font-weight: bold;
      color: #2dcd7c;
      line-height: 50px;
      box-shadow: 9px 6px 16px #d4f4e4;
      margin-left: 30px;
    }
  }
}
</style>